import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { liveWait, fmtClock } from "@/lib/tripPhase";

export const WaitTimer = ({ ride, variant = "dark" }) => {
  const [now, setNow] = useState(Date.now());
  const w = liveWait(ride, now);

  useEffect(() => {
    if (!w.running) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [w.running]);

  if (!ride?.wait_segments?.length) return null;
  const dark = variant === "dark";

  return (
    <div
      className={`rounded-xl p-4 border ${dark ? "bg-slate-800 border-amber-400/30" : "bg-amber-50 border-amber-200"}`}
      data-testid="wait-timer"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Timer className={`w-5 h-5 ${w.running ? "text-amber-400 animate-pulse" : "text-slate-400"}`} />
          <span className={`text-xs uppercase tracking-wide font-semibold ${dark ? "text-amber-300" : "text-amber-700"}`}>
            {w.running ? "Wait timer running" : "Total wait time"}
          </span>
        </div>
        <span className={`text-2xl font-mono font-bold ${dark ? "text-white" : "text-slate-900"}`} data-testid="wait-timer-clock">
          {fmtClock(w.seconds)}
        </span>
      </div>
      {w.isPrivate && (
        <div className={`mt-2 flex justify-between text-sm ${dark ? "text-slate-300" : "text-slate-600"}`}>
          <span data-testid="wait-free-left">
            {w.freeLeft > 0 ? `Free wait left: ${fmtClock(w.freeLeft)}` : `$${w.rate.toFixed(2)}/min after ${w.free} free min`}
          </span>
          <span className="font-semibold" data-testid="wait-charge">Wait charge: ${w.charge.toFixed(2)}</span>
        </div>
      )}
      {w.isPrivate && (
        <div className={`mt-2 pt-2 border-t flex justify-between ${dark ? "border-slate-700" : "border-amber-200"}`}>
          <span className={dark ? "text-slate-400" : "text-slate-600"}>Updated fare</span>
          <span className={`font-bold text-lg ${dark ? "text-lime-400" : "text-teal-700"}`} data-testid="live-total-fare">
            ${w.total.toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
};

export default WaitTimer;
